export const memberListConfigConstant = () => {
    let skeleton = [{ span: 12, height: "36px", classes: "marginTop-16" }]
    for (let i = 0; i < 10; i++) {
        skeleton.push({
            classes: "marginTop-16",
            columns: [
                { span: 1, height: "48px" },
                {
                    span: 7,
                    rows: [
                        { span: 4, height: "24px" },
                        { span: 3, height: "21px", classes: "marginTop-4" },
                    ],
                },
            ],
        })
    }
    return skeleton
}

export const memberListConfig = (memberLength, ctaLabel) => {
    const skeleton = []
    if (ctaLabel) {
        skeleton.push({ span: 6, height: "36px", classes: "marginTop-16" })
    }
    for (let i = 0; i < memberLength; i++) {
        skeleton.push({
            classes: "marginTop-16",
            columns: [
                { span: 1, height: "48px" },
                {
                    rows: [
                        { span: 5, height: "24px" },
                        { span: 5, height: "21px", classes: "marginTop-4" },
                    ],
                },
            ],
        })
    }
    return skeleton
}
